import React, { useContext, useMemo, useState, Fragment, useEffect } from 'react';
import {
  usePromise,
  MasterDetailForm,
  Widget,
  FormSubmitButton,
  FormInput,
  FormatText,
  FormSwitch,
  FormDatePicker,
  Button,
  Icon,
  FormTextArea,
} from '@digital/ui';
import {
  GetBoletimMedicaoPorContratoId,
  CreatBoletimMedicaoPorContrato,
  CreatMedicao,
  gelAllResumoMedicoes,
  GetAllResumoMedicoesCanceladasPorContratoId,
} from '@app/api/boletimMedicao';
import { Collapse, Table, Tooltip } from 'antd';
import * as Yup from 'yup';
import { hasPermission } from '@app/helpers/permissions';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getLoggedIsMRN } from '@app/helpers';
import { GetAquivoExportaHistoricoMedicao } from '@app/api/contrato';

interface AbaResumoMedicoesProps {
  contratoId: string
}

const AbaResumoMedicoes = ({ contratoId }: AbaResumoMedicoesProps) => {

  const [hasGelAllResumoMedicoesConsult, setGelAllResumoMedicoesConsult] = useState();
  const [itemFalorPadrao, setitemFalorPadrao] = useState();
  const [mostrarTabelaMedicaoCancelada, setMostrarTabelaMedicaoCancelada] = useState(false);
  const [isMRN] = useState<boolean>(getLoggedIsMRN());

  const collResumoMedicoes = [
    {
      title: 'Nº',
      dataIndex: 'numero',
      width: '1%',
    },
    {
      title: 'Origem',
      dataIndex: 'tipo',
      width: '5%',
    },
    {
      title: 'Tipo',
      dataIndex: 'tiposMedicoes',
      width: '5%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '10%',
    },
    {
      title: 'Período',
      dataIndex: 'periodo',
      width: '15%',
    },
    {
      title: 'Aditivo vigente',
      dataIndex: 'nmAditivoVigente',
      width: '4%',
    },
    {
      title: 'Valor ',
      dataIndex: 'slFinalMedicao',
      width: '10%',
    },
    {
      title: 'SLA',
      dataIndex: 'sla',
      width: '10%',
      render: (index, item) => {
        return (
          <>
            {item.possuiSla ? (
              <>
                <span>
                  {isEmptyOrSpaces(item.bonusSla) ? (
                    <> N/A </>
                  ) : (
                    <div className={item.bonusSla === 'R$0,00' ? 'spanPenaltSlaBlack' : 'spanBonusSla'}>
                      {' '}
                      {`Bonus: ${item.bonusSla}`}{' '}
                    </div>
                  )}
                  {isEmptyOrSpaces(item.penaltSla) ? (
                    <> N/A</>
                  ) : (
                    <div className={item.penaltSla === 'R$0,00' ? 'spanPenaltSlaBlack' : 'spanPenaltSlaRed'}>
                      {' '}
                      {`Pênalt: ${item.penaltSla}`}
                    </div>
                  )}
                </span>
              </>
            ) : (
              <> N/A</>
            )}
          </>
        );
      },
    },
    {
      title: 'Status SLA',
      dataIndex: 'statusSla',
      width: '10%',
      render: (index, item) => {
        return <>{item.possuiSla ? <>{item.statusSla}</> : <> N/A </>}</>;
      },
    },
    {
      title: 'Valor Real (VALOR - SLA)',
      dataIndex: 'valorReal',
      width: '10%',
    },
    {
      title: 'Status Rateio',
      dataIndex: 'statusRateio',
    },

    {
      title: 'Ações',
      width: '5%',
      render: (index, item) => {
        return (
          <Tooltip title="Ir para BM">
            <Button
              type="link"
              icon="arrows-circled_up_right_2"
              name="irparaBm"
              onClick={() => {
                let urlBase = window.location.origin;
                window.open(urlBase + `/boletimDeMedicoes/detail/${item.id}/${contratoId}`);
              }}
              href="#"
            />
          </Tooltip>
        );
      },
    },
  ];

  const isEmptyOrSpaces = (str: string) => {
    return str === null || str.match(/^ *$/) !== null;
  };

  const spanBonusSla = {
    fontFamily: 'nunitoregular',
    backgroundColor: 'rgba(40, 123, 217, 0.75)',
    color: '#FFFFFF',
    padding: '4px 8px',
    borderRadius: '3px',
    whiteSpace: 'nowrap',
    marginBottom: '2px',
    display: 'table',
  };
  const spanPenaltSlaRed = {
    fontFamily: 'nunitoregular',
    backgroundColor: 'rgba(217, 57, 40, 0.75)',
    color: '#FFFFFF',
    padding: '4px 8px',
    borderRadius: '3px',
    whiteSpace: 'nowrap',
    display: 'table',
  };
  const spanPenaltSlaBlack = {
    color: 'black',
  };

  const [geralData] = usePromise(
    () =>
      contratoId
        ? GetBoletimMedicaoPorContratoId(contratoId).then(data => {
          if (data) {
            data.contratoId = contratoId;
          }
          return data;
        })
        : Promise.resolve(undefined),
    [contratoId, itemFalorPadrao],
    {} as CreatBoletimMedicaoPorContrato,
  );

  const { Panel } = Collapse;

  const onCreateMedicao = (values: any) => {
    CreatMedicao(values).then(resp => {
      if (resp && resp.valid) {
        setitemFalorPadrao(null);
        setitemFalorPadrao(true);
        setGelAllResumoMedicoesConsult(null);
        setGelAllResumoMedicoesConsult(true);
      }
    });
  };

  const [GelAllResumoMedicoesConsult] = usePromise(
    () =>
      contratoId
        ? gelAllResumoMedicoes(contratoId).then(resp => {
          if (resp) {
          }
          return resp;
        })
        : Promise.resolve(undefined),
    [hasGelAllResumoMedicoesConsult],
    [],
  );

  const [GetAllResumoMedicaoCanceladasByContratoId] = usePromise(
    () =>
      contratoId
        ? GetAllResumoMedicoesCanceladasPorContratoId(contratoId).then(resp => {
          return resp;
        })
        : Promise.resolve(undefined),
    [hasGelAllResumoMedicoesConsult],
    [],
  );

  const baixarArquivo = () => {
    if (contratoId) {
      GetAquivoExportaHistoricoMedicao(contratoId);
    }
  };

  useEffect(() => {
    verificarSeExite();
  }, [contratoId]);

  const verificarSeExite = async () => {
    if (contratoId) {
      const result = await GetAllResumoMedicoesCanceladasPorContratoId(contratoId);
      if (result) {
        if (result.length > 0) {
          setMostrarTabelaMedicaoCancelada(true);
        }
      }
    }
  };

  const botoesAcaoGridPqTemporaria = useMemo(() => {
    const actions = [];

    if (hasPermission(['CONTRATO_RESUMO_MEDICOES_CADASTRAR'])) {
      actions.push(
        <FormSubmitButton
          noIcon={true}
          type="primary"
          disabled={!hasPermission(['CONTRATO_RESUMO_MEDICOES_CADASTRAR'])}>
          <FormatText id="ui.commons.save" uppercase />
        </FormSubmitButton>,
      );
    }

    return actions;
  }, []);

  return (
    <>
      {hasPermission(['CONTRATO_RESUMO_MEDICOES_CADASTRAR']) ? (
        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="medicao" header={'Cadastro Manual de Boletim de Medição'} style={{ border: 0 }}>
            <MasterDetailForm
              onSubmit={onCreateMedicao}
              initialValues={geralData}
              validationSchema={Yup.object().shape({
                periodoInicioData: Yup.string().required('Período inicial deve ser informado'),
                periodoFimData: Yup.string().required('Período final deve ser informado'),
                descricao: Yup.string().when('complementar', {
                  is: true,
                  then: Yup.string().required('A descrição deve ser informada'),
                }),
              })}>
              <Widget actions={botoesAcaoGridPqTemporaria}>
                <FormInput label="Número do BM" name="numero" span={3} disabled={true} />

                <FormDatePicker label="Período inicial" name="periodoInicioData" span={3} format="DD/MM/YYYY" />
                <FormDatePicker label="Período final" name="periodoFimData" span={3} format="DD/MM/YYYY" />
                <FormSwitch label="Análise de SLA" name="possuiSla" span={3} />

                <fieldset>
                  <legend>Tipos de Medição</legend>
                  <FormSwitch label="Final" name="final" span={3} />
                  <FormSwitch label="Periódica" name="periodica" span={3} />
                  <FormSwitch label="Complementar" name="complementar" span={3} />
                  <FormSwitch label="Evento" name="evento" span={3} />
                </fieldset>
                <FormTextArea
                  label="Descrição"
                  name="descricao"
                  span={12}
                  rows={3}
                  disabled={false}
                  required={geralData.complementar}
                />
              </Widget>
            </MasterDetailForm>
          </Panel>
        </Collapse>
      ) : (
        <></>
      )}

      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="resumoMedicoes" header={'Resumo das Medições'} style={{ border: 0 }}>
          <Widget
            actions={[
              <Tooltip title="Exporta Historico da Medição">
                <Button
                  type="primary"
                  onClick={() => {
                    baixarArquivo();
                  }}
                  icon="ui-download"
                  name="btnBaixarArquivo">
                  Histórico Medições
                </Button>
              </Tooltip>,
            ]}>
            <PerfectScrollbar>
              <Table
                rowKey="id"
                columns={collResumoMedicoes}
                dataSource={GelAllResumoMedicoesConsult}
                pagination={false}
              />
            </PerfectScrollbar>
          </Widget>
        </Panel>
      </Collapse>

      {isMRN && mostrarTabelaMedicaoCancelada ? (
        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="resumoMedicoesCanceladas" header={'Resumo das Medições - Canceladas'} style={{ border: 0 }}>
            <Widget>
              <PerfectScrollbar>
                <Table
                  rowKey="id"
                  columns={collResumoMedicoes}
                  dataSource={GetAllResumoMedicaoCanceladasByContratoId}
                  pagination={false}
                />
              </PerfectScrollbar>
            </Widget>
          </Panel>
        </Collapse>
      ) : (
        <> </>
      )}
    </>
  );
};
export default AbaResumoMedicoes;
